module.exports = __webpack_public_path__ + "static/media/wng_logo.bf53af0a.png";